import {RatesRequestTestParameters} from '../../../api/pricing/pricing.types';
import {Dispatch} from 'react';
import {UPDATE_RATES_REQUEST_TEST_FILTERS, UpdateRatesRequestTestFiltersAction} from '../types/ratesrequesttest.types';
import {LOCALSTORAGE_RATES_REQUEST_TEST_FILTERS} from '../../../types/app.index';

export const updateRatesRequestTestFilters = (filters: RatesRequestTestParameters) =>
    async (dispatch: Dispatch<UpdateRatesRequestTestFiltersAction>) => {
    localStorage.setItem(LOCALSTORAGE_RATES_REQUEST_TEST_FILTERS, JSON.stringify(filters));
    dispatch({
        type: UPDATE_RATES_REQUEST_TEST_FILTERS,
        payload: {
            filters
        }
    });
};
